export enum StartDayFromSchedule {
  StartDayFromScheduleOption = 0,
  StartDayAfterFirstActivityInDayOption = 1,
}
